// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1cGO1","search":"Settings_search__eZLuG","filter":"Settings_filter__3Ru91"};